var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"promotions-section@3.7.3"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/webassets/webview-promotions-section/promotions-section/3.7.3";

const Sentry = require('@sentry/nextjs');
const applicationName = require('./config/applicationName');
const applicationVersion = require('./config/applicationVersion');

function waitForPerformanceTiming() {
  return new Promise((resolve) => {
    const timeout = setTimeout(() => {
      console.warn('Sentry: performance.timing timeout, initializing anyway');
      resolve();
    }, 1000);

    const checkTiming = () => {
      if (
        window.performance &&
        window.performance.timing &&
        window.performance.timing.domInteractive
      ) {
        clearTimeout(timeout);
        resolve();
      } else {
        setTimeout(checkTiming, 100);
      }
    };
    checkTiming();
  });
}

async function initSentry() {
  await waitForPerformanceTiming();

  Sentry.init({
    dsn: 'https://871fc8585df9a11002c5020e74635e86@o4504046939799552.ingest.us.sentry.io/4507226915405824',
    ignoreErrors: [
      'Non-Error exception captured',
      'Non-Error promise rejection captured',
    ],
    tracesSampleRate: 0.1,
    sampleRate: 0.1,
    environment:
      window.location.host === 'web-apps.pedidosya.com' ? 'live' : 'stg',
    release: `${applicationName}@${applicationVersion}`,
    integrations: [
      new Sentry.BrowserTracing({
        beforeNavigate: (context) => ({
          ...context,
          name: '/promotions',
        }),
      }),
    ],
  });
}

initSentry().catch((error) => {
  console.error('Error initializing Sentry:', error);
});
